import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum ServiceScheduleTableColumn {
  SerialNumber = 'serial_number',
  AssetNumber = 'asset_number',
  AssetModel = 'asset_model',
  AssetMake = 'asset_make',
  AssetType = 'asset_type',
  Location = 'location',
  LastPm = 'last_pm',
  NextPm = 'next_pm',
  NextPmStatusColor = 'next_pm_status_color'
}

export function constructServiceScheduleColumns(
  serialNumberColumnTmp: TemplateRef<any>,
  nextPmColumnTmp: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: ServiceScheduleTableColumn.SerialNumber,
      header: 'Serial Number',
      type: TableColumnType.Template,
      template: serialNumberColumnTmp,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.AssetNumber,
      header: 'Asset #',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.AssetModel,
      header: 'Model',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.AssetMake,
      header: 'Make',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.AssetType,
      header: 'Type',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.Location,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.LastPm,
      header: 'Last Service',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceScheduleTableColumn.NextPm,
      header: 'Next Service Due',
      type: TableColumnType.Template,
      template: nextPmColumnTmp,
      sortable: true
    },
  ];
}
